module.exports = __webpack_public_path__ + "img/37.358410d6.jpg";